import { type ServiceMethod } from '@/application/interfaces/service';

type Params = {
  cartId: string;
};

export type Response = {};

export type Body = {
  coupon: string;
};
export type Data = Params & Body;

const postCoupons: ServiceMethod<Response, Data> =
  (httpClient) => async (data, options) => {
    const { cartId, coupon } = data;

    const { body: response } = await httpClient.post<Response, Body, Params>(
      '/api/v3/carts/{cartId}/coupons',
      {
        ...options,
        body: {
          coupon,
        },
        params: { cartId },
      }
    );

    return response;
  };

export default postCoupons;
